// Vendor Dashboard Data
export const vendorCategoryCounts = {
  Hospital: 2,
  Clinic: 3,
  'Medical Store': 10,
};

export const vendorActivityStatus = {
  Active: 12,
  Inactive: 3,
};

export const vendorMetrics = {
  totalVisitors: 1250,
  totalEnquiries: 450,
  totalBookings: 320,
  totalCancellations: 45,
  totalRevenue: 125000,
  totalRefunds: 15000,
};

export const vendorMetricsByPeriod = {
  daily: {
    visits: [45, 52, 38, 60, 55, 70, 48],
    bookings: [20, 25, 18, 30, 22, 35, 24],
    revenue: [12000, 15000, 10000, 18000, 14000, 21000, 13000],
  },
  weekly: {
    visits: [320, 350, 280, 400, 350],
    bookings: [150, 170, 130, 190, 160],
    revenue: [75000, 85000, 65000, 95000, 80000],
  },
  monthly: {
    visits: [1200, 1350, 1100, 1500, 1400, 1600],
    bookings: [580, 650, 520, 700, 650, 750],
    revenue: [320000, 380000, 290000, 420000, 370000, 450000],
  },
  quarterly: {
    visits: [3500, 4200, 3800, 4500],
    bookings: [1700, 2000, 1850, 2200],
    revenue: [950000, 1150000, 1050000, 1250000],
  },
};

export const vendorPerformanceByDemographic = {
  ageGroups: {
    '18-24': { visits: 320, bookings: 150, revenue: 85000 },
    '25-34': { visits: 480, bookings: 240, revenue: 150000 },
    '35-44': { visits: 350, bookings: 180, revenue: 115000 },
    '45-54': { visits: 220, bookings: 120, revenue: 80000 },
    '55+': { visits: 180, bookings: 80, revenue: 45000 },
  },
  gender: {
    Male: { visits: 750, bookings: 380, revenue: 220000 },
    Female: { visits: 800, bookings: 390, revenue: 255000 },
  },
  healthCondition: {
    'Heart Disease': { visits: 220, bookings: 130, revenue: 85000 },
    Diabetes: { visits: 180, bookings: 110, revenue: 70000 },
    'Respiratory Issues': { visits: 150, bookings: 90, revenue: 55000 },
    'Joint Pain': { visits: 240, bookings: 150, revenue: 95000 },
    'General Checkup': { visits: 460, bookings: 240, revenue: 120000 },
    Other: { visits: 300, bookings: 150, revenue: 75000 },
  },
};

// Individual Vendor Data
export const individualVendorData = [
  {
    id: 1,
    name: 'City Hospital',
    category: 'Hospital',
    status: 'Active',
    location: 'Delhi',
    metrics: {
      totalVisitors: 520,
      totalEnquiries: 180,
      totalBookings: 130,
      totalCancellations: 18,
      totalRevenue: 72000,
      totalRefunds: 8500,
    },
  },
  {
    id: 2,
    name: 'Care Clinic',
    category: 'Clinic',
    status: 'Active',
    location: 'Mumbai',
    metrics: {
      totalVisitors: 320,
      totalEnquiries: 120,
      totalBookings: 85,
      totalCancellations: 12,
      totalRevenue: 43000,
      totalRefunds: 4200,
    },
  },
  {
    id: 3,
    name: 'Health First Medical Store',
    category: 'Medical Store',
    status: 'Active',
    location: 'Bangalore',
    metrics: {
      totalVisitors: 180,
      totalEnquiries: 70,
      totalBookings: 50,
      totalCancellations: 5,
      totalRevenue: 15000,
      totalRefunds: 1200,
    },
  },
];

// User Dashboard Data
export const userMetrics = {
  totalActiveUsers: {
    Android: 8500,
    iOS: 6200,
  },
  totalDownloads: {
    Android: 12000,
    iOS: 9500,
  },
  repeatUsers: {
    Android: 6800,
    iOS: 5100,
  },
};

export const userMetricsByPeriod = {
  daily: {
    activeUsers: [850, 920, 780, 950, 880, 1020, 890],
    newUsers: [120, 150, 100, 180, 130, 200, 140],
    sessionDuration: [8.5, 9.2, 7.8, 9.6, 8.7, 10.2, 8.9],
  },
  weekly: {
    activeUsers: [5800, 6200, 5500, 6500, 6000],
    newUsers: [780, 850, 720, 920, 800],
    sessionDuration: [8.8, 9.5, 8.2, 9.8, 9.1],
  },
  monthly: {
    activeUsers: [24000, 26000, 22000, 27000, 25000, 28000],
    newUsers: [3200, 3500, 2900, 3700, 3300, 3800],
    sessionDuration: [9.1, 9.7, 8.5, 10.1, 9.4, 10.3],
  },
  quarterly: {
    activeUsers: [72000, 78000, 68000, 82000],
    newUsers: [9500, 10500, 8800, 11200],
    sessionDuration: [9.3, 9.9, 8.7, 10.2],
  },
};

export const userDemographics = {
  ageGroups: {
    '18-24': 2500,
    '25-34': 3800,
    '35-44': 2900,
    '45-54': 1800,
    '55+': 1200,
  },
  gender: {
    Male: 5800,
    Female: 6200,
    Other: 200,
  },
  location: {
    Delhi: 2200,
    Mumbai: 1800,
    Bangalore: 1500,
    Hyderabad: 1200,
    Chennai: 1100,
    Other: 4000,
  },
  healthCondition: {
    'Heart Disease': 1800,
    Diabetes: 1500,
    'Respiratory Issues': 1200,
    'Joint Pain': 2000,
    'General Checkup': 3800,
    Other: 1700,
  },
};

export const userRevenueByCategory = {
  'Doctor Consultations': 180000,
  'Health Checkups': 150000,
  'Medicine Orders': 220000,
  'Lab Tests': 85000,
  'Health Products': 65000,
};

export const mostSearchedItems = [
  { name: 'Cardiologists', count: 3200 },
  { name: 'COVID Tests', count: 2800 },
  { name: 'Diabetologists', count: 2500 },
  { name: 'Blood Tests', count: 2200 },
  { name: 'Paracetamol', count: 2000 },
  { name: 'Vitamin Supplements', count: 1800 },
  { name: 'Orthopedic Doctors', count: 1700 },
  { name: 'Health Insurance', count: 1500 },
];

export const mostUsedServices = [
  { name: 'Online Doctor Consultation', count: 4200 },
  { name: 'Medicine Delivery', count: 3800 },
  { name: 'Lab Test Booking', count: 2900 },
  { name: 'Health Checkup Packages', count: 2200 },
  { name: 'Hospital Appointments', count: 1800 },
  { name: 'Health Articles', count: 1500 },
];

export const appPerformance = {
  crashRate: [2.1, 1.8, 1.5, 1.2, 1.0, 0.8, 0.9],
  loadTime: [3.2, 3.0, 2.8, 2.7, 2.5, 2.3, 2.4],
  errorRate: [3.5, 3.1, 2.8, 2.5, 2.3, 2.0, 2.2],
  sessionDuration: [8.5, 8.7, 9.0, 9.3, 9.5, 9.8, 9.6],
}; 